﻿import ActivePage from "../activePage";

export default class SharePointGraphHelper extends ActivePage {

    constructor() {
        super();
        this.image = window.image;
    }

    getSearchCriteria = () => {
        const imageDataContainer = $("#imageDataContainer");
        const form = imageDataContainer.find("#spImageSearchContainer").clone(true);
        const memoryForm = $("<form>").append(form);
        const criteria = pageHelper.formDataToCriteriaList(memoryForm);
        return { criteria: criteria.payLoad };
    }

    viewFileGrid(e, grid) {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
        if (dataItem)
          this.viewFile(dataItem);
    }

    viewFileGallery(listName) {
        const dataItem = this.getSelected(listName);
        if (dataItem)
          this.viewFile(dataItem);
    }

    viewFile(dataItem) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Shared/SharePointGraph/GetPreviewUrl${(dataItem.Name.endsWith('.url') ? "ForLinks":"")}`;

        let retry = 0;
        openPreviewFile();

        function openPreviewFile() {
            $.get(url, { docLibrary: dataItem.DocLibrary, id: dataItem.Id })
                .done(function (result) {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = result.previewUrl;
                    a.target = "_blank"
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                    }, 0);
                })
                .fail(function (e) {
                    if (e.status == 401 && retry < 3) {
                        retry++;
                        const baseUrl = $("body").data("base-url");
                        const url = `${baseUrl}/Graph/SharePoint`;

                        sharePointGraphHelper.getGraphToken(url, () => {
                            openPreviewFile();
                        });
                    }
                    else {
                        pageHelper.showErrors(e.responseText);
                    }
                });
        }
    }

    viewForSignatureFile(e,grid) {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
    
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Shared/SharePointGraph/GetPreviewUrl`;

        $.get(url, { docLibrary: dataItem.DocLibrary, id: dataItem.Id })
            .done(function (result) {
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.href = result.previewUrl;
                a.target = "_blank"
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a);
                }, 0);
            })
            .fail(function (e) {
                pageHelper.showErrors(e.responseText);
            });
    
    }

    refreshGrid(gridName) {
        //cpiLoadingSpinner.show();
        const grid = $("#" + gridName).data("kendoGrid");
        grid.dataSource.read();
        grid.refresh();
        //cpiLoadingSpinner.hide();
    }

    refreshListView = (listName) => {
        const listViewImages = $("#" + listName).data("kendoListView");
        listViewImages.dataSource.read();
    }

    showSearchScreen = () => {
        const imageDataContainer = $("#imageDataContainer");
        imageDataContainer.find("#spImageSearchContainer").toggleClass("d-none");
    }


    deleteFileGrid(e, gridName) {
        e.preventDefault();
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + gridName).data("kendoGrid").dataItem(row);

        const grid = $("#" + e.delegateTarget.id).data("kendoGrid");
        const form = $(e.currentTarget).closest("#imageDataContainer");

        const deletePrompt = form.data("delete-message");
        const title = form.data("delete-title");

        cpiConfirm.delete(title, deletePrompt, function () {
            cpiLoadingSpinner.show();

            $.ajax({
                url: grid.dataSource.transport.options.destroy.url,
                data: { docLibrary: dataItem.DocLibrary, id: dataItem.Id },
                type: "POST",
                success: function (result) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showSuccess(result.success);
                    grid.removeRow($(e.currentTarget).closest("tr"));
                    grid.dataSource._destroyed = [];
                },
                error: function (e) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showErrors(e);
                }
            });
        });
    }

    deleteFileGallery(listName) {
        const dataItem = this.getSelected(listName);
        const listView = $("#" + listName).data("kendoListView");
        const form = $("#" + listName).closest("#imageDataContainer");
        const deletePrompt = form.data("delete-message");
        const title = form.data("delete-title");

        cpiConfirm.delete(title, deletePrompt, function () {
            cpiLoadingSpinner.show();
            $.ajax({
                url: listView.dataSource.transport.options.destroy.url,
                data: { docLibrary: dataItem.DocLibrary, id: dataItem.Id },
                type: "POST",
                success: function (result) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showSuccess(result.success);
                    listView.dataSource.remove(dataItem);
                },
                error: function (e) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showErrors(e);
                }
            });
        });
    }


    editFileGrid(e, grid) {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
        if (dataItem)
           this.editFile(dataItem);
        
    }

    editFileGallery(listName) {
        const dataItem = this.getSelected(listName);
        if (dataItem)
           this.editFile(dataItem);
    }

    editFile(dataItem) {
        var url = dataItem.EditUrl;
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.target = "_blank";
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
        }, 0);
    }

    checkoutFileGrid(e, gridName) {
        e.preventDefault();
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + gridName).data("kendoGrid").dataItem(row);
        if (dataItem)
            this.checkoutFile(dataItem, () => { this.refreshGrid(gridName); })

    }

    checkoutFileGallery(listName) {
        const listView = $("#" + listName).data("kendoListView");
        const dataItem = this.getSelected(listName);
        if (dataItem) 
            this.checkoutFile(dataItem, () => { this.refreshListView(listName);})
    }

    checkoutFile(dataItem,callBack) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Shared/SharePointGraph/CheckoutFile`;
        var self = this;

        cpiLoadingSpinner.show();
        $.get(url, { docLibrary: dataItem.DocLibrary, id: dataItem.Id })
            .done(function (result) {
                pageHelper.showSuccess(result.success);
                callBack();
                cpiLoadingSpinner.hide();
            })
            .fail(function (e) {
                pageHelper.showErrors(e.responseText);
                cpiLoadingSpinner.hide();
            });
    }

    checkinFileGrid(e, gridName) {
        e.preventDefault();
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + gridName).data("kendoGrid").dataItem(row);
        if (dataItem)
            this.checkinFile(dataItem, () => { this.refreshGrid(gridName); })
    }

    checkinFileGallery(listName) {
        const dataItem = this.getSelected(listName);
        if (dataItem)
            this.checkinFile(dataItem, () => { this.refreshListView(listName); })
    }

    checkinFile(dataItem,callBack) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Shared/SharePointGraph/CheckinFile`;
        var self = this;

        cpiLoadingSpinner.show();
        $.get(url, { docLibrary: dataItem.DocLibrary, id: dataItem.Id })
            .done(function (result) {
                pageHelper.showSuccess(result.success);
                callBack();
                cpiLoadingSpinner.hide();
            })
            .fail(function (e) {
                pageHelper.showErrors(e.responseText);
                cpiLoadingSpinner.hide();
            });
    }

    fileVersionGrid(e, gridName) {
        e.preventDefault();
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + gridName).data("kendoGrid").dataItem(row);
        if (dataItem)
            this.fileVersion(dataItem);
    }

    fileVersionGallery(listName) {
        const dataItem = this.getSelected(listName);
        if (dataItem)
            this.fileVersion(dataItem);
    }

    fileVersion(dataItem) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Shared/SharePointGraph/Version`;
        cpiLoadingSpinner.show();

        $.get(url, { docLibrary: dataItem.DocLibrary, name: dataItem.Name, driveItemId: dataItem.Id })
            .done(function (result) {
                const popupContainer = $(".site-content .popup");
                popupContainer.html(result);
                const dialogContainer = $("#spDocumentVersionDialog");

                let entryForm = dialogContainer.find("form")[0];
                dialogContainer.modal("show");
                cpiLoadingSpinner.hide();
                entryForm = $(entryForm);
                entryForm.cpiPopupEntryForm(
                    {
                        dialogContainer: dialogContainer,
                        closeOnSubmit: false,
                    }
                );
            })
            .fail(function (e) {
                cpiLoadingSpinner.hide();
                pageHelper.showErrors(e.responseText);
            });
    }

    downloadFileGrid(e, grid) {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
        if (dataItem)
            this.downloadFile(dataItem);
    }

    downloadFileGallery(listName) {
        const dataItem = this.getSelected(listName);
        if (dataItem)
            this.downloadFile(dataItem);
    }

    downloadFile(dataItem) {
        var url = dataItem.DownloadUrl;
        var downloadName = dataItem.Name;

        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.target = "_blank";
        a.download = downloadName;
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
        }, 0);
    }


    addFileGrid(gridName) {
        const grid = $("#" + gridName).data("kendoGrid");
        const imageContainer = $("#" + gridName).closest(".image-container");
        if (grid)
            this.addFile(grid, imageContainer);
    }

    addFileGallery(listName) {
        const listView = $("#" + listName).data("kendoListView");
        const imageContainer = $("#" + listName).closest(".image-container");

        if (listView)
            this.addFile(listView, imageContainer);
    }


    addFile(grid, imageContainer) {
        const folderId = imageContainer.data("folder-id");

        $.ajax({
            url: grid.dataSource.transport.options.create.url,
            data: {folderId},
            type: "Get",
            success: function (result) {
                const popupContainer = $(".site-content .popup");
                popupContainer.html(result);
                const dialogContainer = $("#documentEditorDialog");

                let entryForm = dialogContainer.find("form")[0];
                dialogContainer.modal("show");
                entryForm = $(entryForm);
                entryForm.cpiPopupEntryForm(
                    {
                        dialogContainer: dialogContainer,
                        closeOnSubmit: false,
                        beforeSubmit: function () {
                            cpiLoadingSpinner.show();
                        },
                        afterSubmit: function (response) {
                            cpiLoadingSpinner.hide();
                            pageHelper.handleSignatureWorkflow(response);
                            pageHelper.handleEmailWorkflow(response);
                            
                            dialogContainer.modal("hide");
                            setTimeout(() => {
                                grid.dataSource.read();
                                grid.refresh();
                            }, 2000);
                        }
                    }
                );
            },
            error: function (e) {
                cpiLoadingSpinner.hide();
                pageHelper.showErrors(e);
            }
        });
    }

    modifyFileGrid(e, gridName, activePage) {
        const grid = $("#" + gridName).data("kendoGrid");
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + gridName).data("kendoGrid").dataItem(row);
        console.log(dataItem);
        if (dataItem)
            this.modifyFile(dataItem, grid, activePage);
    }

    modifyFileGallery(listName) {
        const listView = $("#" + listName).data("kendoListView");
        const dataItem = this.getSelected(listName);
        if (dataItem)
            this.modifyFile(dataItem, listView);
    }

    modifyFile(dataItem, grid,activePage) {
        cpiLoadingSpinner.show();

        $.ajax({
            url: grid.dataSource.transport.options.update.url,
            data: { docLibrary: dataItem.DocLibrary, docLibraryFolder: dataItem.DocLibraryFolder, recKey: dataItem.RecKey, driveItemId: dataItem.Id, listItemId: dataItem.ListItemId, parentId: dataItem.ParentId },
            type: "Get",
            success: function (result) {
                const popupContainer = $(".site-content .popup");
                popupContainer.html(result);
                const dialogContainer = $("#documentEditorDialog");

                let entryForm = dialogContainer.find("form")[0];
                dialogContainer.modal("show");
                cpiLoadingSpinner.hide();
                entryForm = $(entryForm);
                entryForm.cpiPopupEntryForm(
                    {
                        dialogContainer: dialogContainer,
                        closeOnSubmit: false,
                        beforeSubmit: function () {
                            var actGrid = $("#documentVerificationActGrid").data("kendoGrid")
                            if (actGrid) {
                                var actGridChanged = false;
                                var actGridDS = actGrid.dataSource;
                                $.each(actGridDS._data, function ()
                                {
                                    if (this.dirty == true)
                                    {
                                        actGridChanged = true;
                                    }
                                });
                                if (actGridChanged && !confirm(dialogContainer.data("cancel-message"))) {                                              
                                    throw new Error("Aborted - Confirm cancelled.");
                                }
                            } 
                            cpiLoadingSpinner.show();
                        },
                        afterSubmit: function (response) {
                            cpiLoadingSpinner.hide();
                            if (response) {
                                pageHelper.handleEmailWorkflow(response);
                            }
                            else {
                                pageHelper.showSuccess(result.success);
                            }                            
                            grid.dataSource.read();
                            grid.refresh();
                            dialogContainer.modal("hide");
                            const currentPage = window[activePage];
                            currentPage.image.refreshSharePointDefaultImage(currentPage);
                        }
                    }
                );
            },
            error: function (e) {
                cpiLoadingSpinner.hide();
                pageHelper.showErrors(e);
            }
        });
    }


    getSelected(listName) {
        const listView = $("#" + listName).data("kendoListView");
        const index = listView.select().index();
        const dataItem = listView.dataSource.view()[index];
        return dataItem;
    }

    previewFile(docLibrary,id) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Shared/SharePointGraph/GetPreviewUrl`;

        $.get(url, { docLibrary, id})
            .done(function (result) {
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.href = result.previewUrl;
                a.target = "_blank"
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a);
                }, 0);
            })
            .fail(function (e) {
                pageHelper.showErrors(e.responseText);
            });
    }
   
    restoreVersion(e, grid) {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
        if (dataItem) {
            const container = $("#spDocumentVersionDialog");
            const restorePrompt = container.data("restore-message");
            const title = container.data("restore-title");

            cpiConfirm.confirm(title, restorePrompt, function () {
                $.get(dataItem.RestoreUrl)
                    .done(() => {
                        $("#" + grid).data("kendoGrid").dataSource.read();
                    })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
            
        }
            
    }

    downloadDocs = (gridName, docLibrary,docLibraryFolder,recKey) => {
        const grid = $(gridName).data("kendoGrid");
        const keys = grid.selectedKeyNames();
        const selection = [];

        if (keys.length > 0) {

            const gridData = grid.dataSource.data();

            for (const item in keys) {
                const rec = gridData.find(r => r.Id == keys[item]);
                if (rec) {
                    const selected = { DriveItemId: rec.Id, Name: rec.Name };
                    selection.push(selected);
                }
            }

            const baseUrl = $("body").data("base-url");
            const url = `${baseUrl}/Shared/SharePointGraph/DownloadFiles`;

            let downloadForm = $("#documentsDownload").last();
            if (downloadForm.length > 0) {
                downloadForm.remove();
            }
            const selectionString = JSON.stringify(selection);
            console.log("selectionString", selectionString);
            //$(`<form action="${url}" method="post" id="documentsDownload"><input type="hidden" name="docLibrary" value="${docLibrary}"/><input type="hidden" name="docLibraryFolder" value="${docLibraryFolder}"/><input type="hidden" name="recKey" value="${recKey}"/><input type="hidden" name="selection" value='${selectionString}'/></form>`).appendTo('body').submit();
            $(`<form action="${url}" method="post" id="documentsDownload"><input type="hidden" name="docLibrary" value="${docLibrary}"/><input type="hidden" name="selection" value='${selectionString}'/></form>`).appendTo('body').submit();
        }
    }

    pullDocuSignDoc = (e, grid,callBack) => {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
        let retry = 0;

        if (dataItem && dataItem.SentToDocuSign) {
            if (dataItem.SignatureCompleted) {
                const repullPrompt = $("#" + grid).closest(".image-container").data("repull-prompt");
                const title = $("#" + grid).closest(".image-container").data("confirm");

                cpiConfirm.confirm(title, repullPrompt, function () {
                    pullCompletedDoc();
                });
            }
            else {
                const pullPrompt = $("#" + grid).closest(".image-container").data("pull-prompt");
                const title = $("#" + grid).closest(".image-container").data("confirm");

                cpiConfirm.confirm(title, pullPrompt, function () {
                    pullCompletedDoc();
                });
            }

            function pullCompletedDoc() {
                const baseUrl = $("body").data("base-url");
                const url = `${baseUrl}/Shared/DocuSign/GetSignedDocumentsAndSaveToSharePoint`;

                cpiLoadingSpinner.show();
                $.post(url, {
                    viewModelParam: {
                        EnvelopeId: dataItem.EnvelopeId,
                        DocLibrary: dataItem.DocLibrary,
                        DocLibraryFolder: dataItem.DocLibraryFolder,
                        ParentId: dataItem.ParentId,
                        Id: dataItem.Id,
                        DocName: dataItem.Name,
                    }
                })
                    .done((result) => {
                        if (callBack) callBack();
                        $("#" + grid).data("kendoGrid").dataSource.read();
                        cpiLoadingSpinner.hide();
                    })
                    .fail(function (error) {
                        if ((error.status == 401 || error.responseText.indexOf("InvalidAuthenticationToken") > 0) && retry < 3) {
                            retry++;
                            const baseUrl = $("body").data("base-url");
                            const url = `${baseUrl}/Graph/SharePoint`;

                            sharePointGraphHelper.getGraphToken(url, () => {
                                pullCompletedDoc();
                            });
                        }
                        else {
                            cpiLoadingSpinner.hide();
                            if (error.responseJSON) {
                                const jsonError = error.responseJSON;
                                pageHelper.showErrors(jsonError.errorMessage);
                                if (jsonError.consentRequired) {
                                    console.log(jsonError.url);
                                    window.open(jsonError.url);
                                }
                            }
                            else
                                pageHelper.showErrors(error);
                        }
                    });
            }
        }
    }

    pushDocuSignDoc = (e, grid,callBack) => {
        const row = $(e.target).closest("tr");
        const dataItem = $("#" + grid).data("kendoGrid").dataItem(row);
        let retry = 0;

        if (dataItem) {
            const title = $("#" + grid).closest(".image-container").data("confirm");
            if (dataItem.SentToDocuSign) {
                const resendPrompt = $("#" + grid).closest(".image-container").data("resend-prompt");
                cpiConfirm.confirm(title, resendPrompt, function () {
                    pushDoc();
                });
            }
            else {
                const sendPrompt = $("#" + grid).closest(".image-container").data("send-prompt");
                cpiConfirm.confirm(title, sendPrompt, function () {
                    pushDoc();
                });
            }

            function pushDoc() {
                const baseUrl = $("body").data("base-url");
                const url = `${baseUrl}/Shared/DocuSign/ResendEnvelopeFromFileUpload`;
                const workflow = {
                    UserFile: {
                        FileName: dataItem.Name,
                        StrId: dataItem.Id,
                        Name: dataItem.Name
                    },
                    QESetupId: dataItem.QESetupId,
                    ParentId: dataItem.ParentId,
                    ScreenCode: dataItem.ScreenCode,
                    RoleLink: dataItem.RoleLink,
                    SystemTypeCode: dataItem.SystemTypeCode,
                    SharePointDocLibrary: dataItem.DocLibrary
                };

                cpiLoadingSpinner.show();
                $.post(url, { workflow })
                    .done((result) => {
                        cpiLoadingSpinner.hide();
                        $("#" + grid).data("kendoGrid").dataSource.read();
                        if (callBack) callBack();
                    })
                    .fail(function (error) {
                        if ((error.status == 401 || error.responseText.indexOf("InvalidAuthenticationToken") > 0) && retry < 3) {
                            retry++;
                            const baseUrl = $("body").data("base-url");
                            const url = `${baseUrl}/Graph/SharePoint`;

                            sharePointGraphHelper.getGraphToken(url, () => {
                                pushDoc();
                            });
                        }
                        else {
                            cpiLoadingSpinner.hide();
                            if (error.responseJSON) {
                                const jsonError = error.responseJSON;
                                pageHelper.showErrors(jsonError.errorMessage);
                                if (jsonError.consentRequired) {
                                    console.log(jsonError.url);
                                    window.open(jsonError.url);
                                }
                            }
                            else
                                pageHelper.showErrors(error);
                        }

                    });
            }

        }
    }

    downloadLetterTemplate(e, grid) {
        e.preventDefault();
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const container = $("#fileTemplateGridContainer");
        const url = container.data("download-url");
        console.log(dataItem);
        const data = { sys: dataItem.SystemType, templateFile: dataItem.TemplateFile, id: dataItem.Id};
        window.fileUtility.getFileStream(url, data);
    }

    openSharePointUrl(url) {
        let retry = 0;
        openSharePointUrlWithRetry();

        function openSharePointUrlWithRetry() {
            $.get(url)
                .done(function (result) {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = result.previewUrl;
                    a.target = "_blank";
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                    }, 0);
                })
                .fail(function (e) {
                    if (e.status == 401 && retry < 3) {
                        retry++;
                        const baseUrl = $("body").data("base-url");
                        const url = `${baseUrl}/Graph/SharePoint`;

                        sharePointGraphHelper.getGraphToken(url, () => {
                            openSharePointUrlWithRetry();
                        });
                    }
                    else {
                        pageHelper.showErrors(e.responseText);
                    }
                });
        }
        
    }


    imageReadErrorHandler(e,docTree) {
        if (e.xhr.status == 401) {
            const baseUrl = $("body").data("base-url");
            const url = `${baseUrl}/Graph/SharePoint`;
            $(".documents-tab").addClass("d-none");

            sharePointGraphHelper.getGraphToken(url, () => {
                //this.read();
                e.sender.read();

                if (docTree.length > 0) {
                    const docTreeView = $(`#${docTree}`);
                    if (docTreeView) {
                        docTreeView.data("kendoTreeView").dataSource.read();
                    }
                }
                $(".documents-tab").removeClass("d-none");
            });
        }
    }

    //Opens Graph authentication in new tab
    //  Auth endpoint closes new tab after authentication if returnUrl is empty
    //  Auth endpoint redirects to returnUrl if not empty
    //Executes callback function after authentication
    getGraphToken(url, callback)  {
        const statusKey = "graph-signin";
        const intervalId = setInterval(function () { checkAuth(); }, 1000);
        const checkAuth = () => {
            const status = localStorage.getItem(statusKey);
            if (status) {
                clearInterval(intervalId);
                localStorage.removeItem(statusKey);

                if (status == "ok" && callback)
                    callback();
            }
        };

        localStorage.setItem(statusKey, "");
        window.open(url);
    }
   
 

}